const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-mail/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { MailListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-mail/list-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-mail/list')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: MailListFilterParamSchema
});